export default __webpack_public_path__ + "static/media/achievement_show.b270d366.png";